import { Component } from "@angular/core";
import { CustomModal } from "../../../core/components/base-modals";
import { BpModalHasSave } from "@models/interfaces/bp-modal-has-save";
import { externalPaths } from "@config";

@Component({
	templateUrl: "./offline-modal.component.html",
	styleUrls: ["./offline-modal.component.scss"],
	standalone: false
})
export class OfflineModalComponent extends CustomModal implements BpModalHasSave {
	public get baseUrl(): string {
		return externalPaths.statusUrl;
	}

	public save(): void {
		window.location.href = this.baseUrl;
	}
}
